import {
  Container,
  Grid,
  GridList,
  GridListTile,
  GridListTileBar,
  IconButton,
  ListSubheader,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { default as React, useState } from "react";
import firebase from "./firebase";
import Show from "./Show";
import { CurrentPosition, Store } from "./types";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function List(props: {
  tileData: Store[];
  position: CurrentPosition;
  deletable?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState<Store | undefined>();

  const handleClickOpen = (store: Store) => () => {
    setTarget(store);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = (id: string) => async (e: React.MouseEvent) => {
    if (window.confirm("削除しますか？")) {
      e.stopPropagation();
      const db = firebase.firestore();
      await db.collection("store").doc(id).delete();
      window.location.reload();
      /* 
      const storage = firebase.storage();
      const path = "store/" + id;
      const storageRef = storage.ref().child(path);
      storageRef.delete();
      */
    }
  };

  if (props.tileData.length === 0)
    return (
      <Container
        maxWidth="sm"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography style={{ marginTop: "100px", marginBottom: "20px" }}>
          まだ何も表示するものがありません
        </Typography>
        <img alt="Empty" style={{ width: "90%", height: "auto" }} src="/home.svg"></img>
        <Typography style={{ marginTop: "20px" }}>写真を投稿してみてください！</Typography>
      </Container>
    );

  return (
    <Container maxWidth="sm" disableGutters>
      <GridList
        cellHeight={180}
        cols={2}
        style={{
          margin: 0,
          width: "100%",
        }}
      >
        <GridListTile key="Subheader" cols={2} style={{ height: "auto" }}>
          <ListSubheader>
            <Grid container direction="row" alignItems="center">
              <Grid item>
                <div style={{ verticalAlign: "middle", display: "inline-flex" }}>
                  <LocationOnIcon />
                </div>
              </Grid>
              <Grid item>
                <Typography>{props.position.name}</Typography>
              </Grid>
            </Grid>
          </ListSubheader>
        </GridListTile>

        {props.tileData
          .sort(function (a, b) {
            const a_len =
              (props.position.latitude - a.latitude) ** 2 +
              (props.position.longitude - a.longitude) ** 2;
            const b_len =
              (props.position.latitude - b.latitude) ** 2 +
              (props.position.longitude - b.longitude) ** 2;
            if (a_len < b_len) return -1;
            if (a_len > b_len) return 1;
            return 0;
          })
          .map((tile) => {
            let subtitle = "";

            if (tile.createdTime && tile.createdTime instanceof Date) {
              subtitle = (tile.createdTime as Date).toLocaleDateString();
            }

            let image = "/noimage.png";
            if (tile.thumbnail !== "") {
              image = tile.thumbnail;
            } else if (tile.images.length !== 0) {
              image = tile.images[0];
            }

            return (
              <GridListTile key={tile.id} onClick={handleClickOpen(tile)}>
                <img src={image} alt={tile.title} />
                <GridListTileBar
                  title={tile.title}
                  subtitle={subtitle}
                  actionIcon={
                    <div>
                      {props.deletable && (
                        <IconButton aria-label={`削除`} onClick={handleDelete(tile.id)}>
                          <DeleteIcon color="primary" />
                        </IconButton>
                      )}
                    </div>
                  }
                />
              </GridListTile>
            );
          })}
      </GridList>

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        {target && <Show {...target} handleClose={handleClose}></Show>}
      </Dialog>
    </Container>
  );
}
